import { ErrorBoundary } from '@sentry/react'
import { CssBaseline, ThemeProvider } from '@mui/material'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { AuthProvider } from './auth/AuthProvider'
import { Rotte } from './routes'
import { tema } from './tema'
import './stile.css'

// Opt-in ai comportamenti di React Router v7 per non accumulare debito.
const future = { v7_startTransition: true, v7_relativeSplatPath: true } as const

// Cache condivisa per le letture da PostgREST: dedup delle richieste in volo,
// dati "freschi" per mezzo minuto, un solo retry. Le liste e gli autocompletamenti
// da SP3 in poi passano di qui.
const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 30_000, retry: 1, refetchOnWindowFocus: false } },
})

export function App() {
  return (
    <ThemeProvider theme={tema}>
    <CssBaseline />
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <BrowserRouter future={future}>
          {/* Dentro il router: un errore di rendering di una pagina diventa una
              segnalazione con la rotta nel contesto, invece di uno schermo bianco. */}
          <ErrorBoundary fallback={<p role="alert">Qualcosa e andato storto. Ricarica la pagina.</p>}>
            <Rotte />
          </ErrorBoundary>
        </BrowserRouter>
      </AuthProvider>
    </QueryClientProvider>
    </ThemeProvider>
  )
}
